module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img24.3c889271.jpg";